import { PrivateImage } from "@/components/PrivateMedia";
import React, { useRef } from 'react';
import { useI18n } from '@/contexts/LanguageContext';

export default function FullPhoto({ src, className = '' }) {
  const dialog = useRef(null);
  const { lang } = useI18n();
  if (!src) return null;
  return <>
    <button type="button" className="block w-full rounded-md bg-black/5 focus-visible:outline focus-visible:outline-2" onClick={() => dialog.current.showModal()} aria-label={lang === 'it' ? 'Apri foto intera' : 'Open full photo'}>
      <PrivateImage src={src} alt={lang === 'it' ? 'Foto del profilo' : 'Profile photo'} className={`w-full object-contain ${className}`} />
    </button>
    <dialog ref={dialog} aria-label={lang === 'it' ? 'Foto intera' : 'Full photo'} className="fixed inset-0 m-auto w-[96vw] max-w-6xl max-h-[96dvh] p-3 rounded-lg bg-slate-950 text-white backdrop:bg-black/80" onClick={e => { if (e.target === e.currentTarget) dialog.current.close(); }}>
      <div className="flex justify-end mb-2"><button type="button" autoFocus onClick={() => dialog.current.close()} className="px-4 py-2 border rounded">{lang === 'it' ? 'Chiudi' : 'Close'} ×</button></div>
      <PrivateImage src={src} alt={lang === 'it' ? 'Foto del profilo intera' : 'Full profile photo'} className="w-full h-[78dvh] object-contain" />
    </dialog>
  </>;
}
